import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
declare const GDPRPlugin: any;

@Directive({
  selector: '[appModifyCookieLinks]',
})
export class ModifyCookiesLinkDirective implements AfterViewInit {
  private observer!: MutationObserver;

  private cookieLinkSelector = `a[href*="#cookiesSettings"]`;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.modifyLinks();
    this.observeDomChanges();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private modifyLinks(nodes?: HTMLElement[]) {
    // Use the provided nodes or query for the default set of links
    const links =
      nodes ??
      Array.from(
        this.el.nativeElement.parentElement.querySelectorAll(
          this.cookieLinkSelector
        )
      );

    links.forEach((link: HTMLElement) => {
      link.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent default behavior

        const modal = document.getElementById('ct-ultimate-gdpr-cookie-modal');

        if (modal) {
          // Call the function from the window object
          if (typeof (GDPRPlugin.updateCookieModal) === 'function') {
            GDPRPlugin.updateCookieModal();
          } else {
            console.error('updateCookieModal function is not available.');
          }
          modal.style.display = 'block';
        } else {
          console.error('Cookie settings modal not found in the DOM.');
        }
      });
    });
  }

  private observeDomChanges() {
    const observer = new MutationObserver((mutations) => {
      const addedLinks: HTMLElement[] = [];

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if ((node as HTMLElement).matches?.(this.cookieLinkSelector)) {
            // If the node itself is a link
            addedLinks.push(node as HTMLElement);
          } else if ((node as HTMLElement).querySelectorAll) {
            // If the node contains links, query them and cast to HTMLElement
            addedLinks.push(
              ...Array.from(
                (node as HTMLElement).querySelectorAll(this.cookieLinkSelector)
              ).map((el) => el as HTMLElement)
            );
          }
        });
      });

      if (addedLinks.length > 0) {
        // Ensure addedLinks contains only distinct elements
        const distinctLinks = Array.from(new Set(addedLinks));

        this.modifyLinks(distinctLinks); // Pass only the collected links
      }
    });

    observer.observe(this.el.nativeElement.parentElement, {
      childList: true,
      subtree: true,
    });
  }
}
